export function validateBreakPrice(prices) {
  if (!prices || prices.length === 0)
    return [false, 'You must provide at least one price.'];
  const set = new Set(prices);
  if (prices.length !== set.size)
    return [false, 'You cannot include duplicate prices.'];
  return [true, ''];
}
